export enum StateEnum {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  STOPPED = 'STOPPED',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum QueryPropertiesOrderByColumn {
  ID = 'ID',
  CREATED_AT = 'CREATED_AT',
}

export enum Sign {
  INCREASE = 'increase',
  ZERO = 'no_prior_data',
  NO_DATA = 'no_data',
}
